import * as React from 'react';
import type {Datapoint} from '@deviceinsight/ng-ui-api-client';
import {TFunction, Trans} from '@deviceinsight/ng-ui-scale-lib/api';

type Props = {
	datapoint: Partial<Datapoint>;
};
export default class DatapointTrans extends React.PureComponent<Props> {
	render() {
		const {datapoint} = this.props;
		return (
			<span title={datapoint.name}>
				<Trans i18nKey={`datapoints.${datapoint.name}`}>{datapoint.name}</Trans>
			</span>
		);
	}
}
export function translateDatapoint(datapoint: Partial<Datapoint>, t: TFunction): string {
	return t(`datapoints.${datapoint.name}`, {
		defaultValue: datapoint.name
	});
}
